import React, { useMemo } from "react";
import { OrderModifiergroup } from "../../utils/order/OrderModifiergroup";
import { OrderModifierarticle } from "../../utils/order/OrderModifierarticle";
import mynOberStore from "../../utils/flux/MynOberStore";
import GetCurrency from "../../utils/functions/GetCurrency";
import {
  Button,
  Checkbox,
  Chip,
  DialogActions,
  DialogContent,
  Fade,
  IconButton,
  List,
  ListItem,
  Paper,
  Popper,
  Radio,
  TextField,
  Typography,
  withStyles,
} from "@material-ui/core";
import AmountAddRemove from "../AmountAddRemove";
import withIntl from "../../utils/withIntl";
import { OrderArticle } from "../../utils/order/OrderArticle";
import * as mynOberActions from "../../utils/flux/MynOberActions";
import { makeStyles } from "@material-ui/core/styles";
import zIndex from "@material-ui/core/styles/zIndex";
import WarningIcon from "@material-ui/icons/Warning";
import scrollIntoView from "scroll-into-view";
import CloseIcon from "@material-ui/icons/Close";
import { useDialog } from "../dialogs/DialogProvider";
import DialogExtra from "../dialogs/DialogExtra";

const useStyles = makeStyles((theme) => ({
  paper: {
    border: "1px solid",
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
  },
  list: {
    backgroundColor: theme.palette.background.default,
    borderTop: "1px solid " + theme.palette.background.tertiary,
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: "8px",
    borderBottom: "1px solid " + theme.palette.background.tertiary,
  },
  listItem: {
    borderBottom: "1px solid",
    borderBottomColor: theme.palette.background.tertiary,
  },
}));

export const CircularButton = withStyles({
  root: {
    borderRadius: "25px",
  },
})(Button);

const DialogContentWithoutPadding = withStyles({
  root: {
    padding: 0,
  },
})(DialogContent);

var modifiergroupName = null;
var numerable = false;
var max = 0;

function HandheldViewMenuArticleDetailed(props) {
  const classes = useStyles();
  const [openDialog, closeDialog] = useDialog();

  let modifiergroups = [];
  if (props.article != null) {
    modifiergroups = mynOberStore.menu.getModifiergroupsWithModifierarticlesByModifiergroupIds(
      props.article.modifiergroupIds
    );
  }
  const [orderModifiergroups, setOrderModifiergroups] = React.useState(
    modifiergroups.map((modifiergroup) => {
      return new OrderModifiergroup(
        modifiergroup,
        modifiergroup.modifierarticles.map((modifierarticle) => {
          return new OrderModifierarticle(modifierarticle, 0);
        })
      );
    })
  );

  const [count, setCount] = React.useState(1);
  const [remark, setRemark] = React.useState("");
  const [anchorPopover, setAnchorPopover] = React.useState(null);
  const popoverIsOpen = Boolean(anchorPopover);
  const id = popoverIsOpen ? "transitions-popper" : undefined;

  const handleClosePopover = () => {
    setAnchorPopover(null);
  };

  const handleAnchorPopover = (orderModifiergroupId) => {
    let domElement = document.getElementById("orderModifiergroupSpan-" + orderModifiergroupId);
    if (domElement != null) {
      modifiergroupName = domElement.innerHTML;
      setAnchorPopover(domElement);
      setTimeout(() => {
        handleClosePopover();
      }, 3000);

      scrollIntoView(domElement, {
        time: 500,
        align: {
          top: 0,
          topOffset: 0,
        },
      });
    }
  };

  const onModifierarticleClicked = (
    orderModifiergroup: OrderModifiergroup,
    orderModifierarticle: OrderModifierarticle
  ) => {
    if (!orderModifiergroup.numerable) {
      if (orderModifiergroup.multiple && orderModifiergroup.optional) {
        orderModifierarticle.count = orderModifierarticle.count === 0 ? 1 : 0;
        setOrderModifiergroups([...orderModifiergroups]);
      } else if (orderModifiergroup.multiple && !orderModifiergroup.optional) {
        orderModifierarticle.count = orderModifierarticle.count === 0 ? 1 : 0;
        setOrderModifiergroups([...orderModifiergroups]);
      } else if (!orderModifiergroup.multiple && orderModifiergroup.optional) {
        if (orderModifierarticle.count === 0) {
          orderModifiergroup.orderModifierarticles.forEach((other) => {
            other.count = 0;
          });
        }
        orderModifierarticle.count = orderModifierarticle.count === 0 ? 1 : 0;
        setOrderModifiergroups([...orderModifiergroups]);
      } else if (!orderModifiergroup.multiple && !orderModifiergroup.optional) {
        orderModifiergroup.orderModifierarticles.forEach((other) => {
          other.count = 0;
        });
        orderModifierarticle.count = 1;
        setOrderModifiergroups([...orderModifiergroups]);
      }
    }
  };

  const checkExtraMessage = () => {
    closeDialog();
    openDialog({
      children: (
        <DialogExtra
          content={props.article.extraMessage}
          onOkClicked={() => {
            addToOrderClicked();
          }}
        />
      ),
    });
  };

  const addToOrderClicked = () => {
    let modifierCheck = hasCorrectModifiergroupSelection();
    if (modifierCheck.isCorrect) {
      let orderModifiergroupsToAdd = [];
      orderModifiergroups.forEach((orderModifiergroup) => {
        if (orderModifiergroup.count > 0) {
          let orderModifierarticles = [];
          orderModifiergroup.orderModifierarticles.forEach((orderModifierarticle) => {
            if (orderModifierarticle.count > 0) {
              orderModifierarticles.push(orderModifierarticle);
            }
          });
          if (orderModifierarticles.length > 0) {
            orderModifiergroupsToAdd.push(new OrderModifiergroup(orderModifiergroup, orderModifierarticles));
          }
        }
      });

      let orderArticle = new OrderArticle(
        props.article,
        count,
        orderModifiergroupsToAdd,
        remark !== "" ? remark : null
      );
      mynOberActions.addOrderArticle(orderArticle);
      closeDialog();
    } else {
      numerable = modifierCheck.numerable;
      max = modifierCheck.max;
      handleAnchorPopover(modifierCheck.modifiergroupId);
    }
  };

  const hasCorrectModifiergroupSelection = () => {
    let result = { isCorrect: true };
    // If incorrect one found, return error
    orderModifiergroups.some((orderModifiergroup) => {
      if (!orderModifiergroup.optional) {
        // Find minimal one selected
        if (
          !orderModifiergroup.orderModifierarticles.some((orderModifierarticle) => {
            return orderModifierarticle.count;
          })
        ) {
          result = {
            isCorrect: false,
            modifiergroupName: orderModifiergroup.name,
            modifiergroupId: orderModifiergroup.id,
            numerable: false,
            max: 0,
          };
          return true; // Found incorrect modifiergroup selection
        }
      }
      if (orderModifiergroup.numerable && orderModifiergroup.maxN > 0) {
        let countModifierarticles = 0;
        orderModifiergroup.orderModifierarticles.forEach((orderModifierarticle) => {
          countModifierarticles += orderModifierarticle.count;
        });
        if (countModifierarticles > orderModifiergroup.maxN * count) {
          // Numerable is not followed up
          result = {
            isCorrect: false,
            modifiergroupName: orderModifiergroup.name,
            modifiergroupId: orderModifiergroup.id,
            numerable: true,
            max: orderModifiergroup.maxN * count,
          };
          return true;
        }
      }
      return false;
    });
    return result;
  };

  const orderArticlePrice = useMemo(() => {
    if (props.article == null) {
      return 0;
    } else {
      let total = 0;
      total += props.article.price * count;
      orderModifiergroups.forEach((orderModifiergroup: OrderModifiergroup) => {
        orderModifiergroup.orderModifierarticles.forEach((orderModifierarticle: OrderModifierarticle) => {
          if (orderModifierarticle.isSideDish && false) {
            total += orderModifierarticle.count * orderModifierarticle.price;
          } else {
            total += orderModifierarticle.count * orderModifierarticle.price * count;
          }
        });
      });
      return total;
    }
  }, [count, orderModifiergroups, props.article]);

  return (
    <>
      <DialogContentWithoutPadding>
        <IconButton
          style={{ position: "absolute", top: 0, right: 0, zIndex: 10 }}
          aria-label="close"
          onClick={() => {
            closeDialog();
          }}
        >
          <CloseIcon />
        </IconButton>
        <div
          style={{
            textAlign: "center",
          }}
        >
          {props.article != null ? (
            <div>
              <div
                style={{
                  display: "inline-flex",
                  justifyContent: "space-between",
                  width: "100%",
                  paddingTop: "16px",
                  paddingBottom: "16px",
                }}
              >
                <div
                  style={{
                    textAlign: "center",
                    flex: "1 1 auto",
                  }}
                >
                  {!mynOberStore.isHandheld() && props.article.path !== null ? (
                    <img
                      style={{
                        overflow: "hidden",
                        borderRadius: "8px",
                        maxWidth: "calc(100% - 32px)",
                        maxHeight: "calc(100% - 32px)",
                        height: "300px",
                        width: "450px",
                        objectFit: "contain",
                      }}
                      alt={props.article.name}
                      src={props.article.path}
                    />
                  ) : null}
                </div>
              </div>
              <div
                style={{
                  textAlign: "center",
                  display: "inline-flex",
                  flexDirection: "column",
                  width: "100%",
                  maxWidth: "400px",
                }}
              >
                <div
                  className={classes.borderAccent}
                  style={{
                    display: "inline-flex",
                    flexDirection: "column",
                    textAlign: "start",
                    width: "calc(100% - 64px)",
                    alignSelf: "center",
                    margin: "0 32px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12pt",
                      whiteSpace: "wrap",
                      textOverflow: "ellipsis",
                      paddingBottom: "3px",
                      fontFamily: "Poppins",
                      fontWeight: "bold",
                    }}
                  >
                    {props.article.name}
                  </span>
                  {props.article.description != null ? (
                    <span
                      style={{
                        fontSize: "14px",
                        lineHeight: "14px",
                        color: "slategray",
                        margin: "3px 0",
                        fontFamily: "Poppins",
                      }}
                    >
                      {props.article.description}
                    </span>
                  ) : null}
                </div>
                <div
                  style={{
                    display: "inline-flex",
                    width: "calc(100% - 64px)",
                    alignSelf: "center",
                    marginBottom: "8px",
                    marginLeft: "32px",
                    marginRight: "32px",
                  }}
                >
                  {props.article.count !== 0 ? (
                    <Chip
                      style={{ alignSelf: "flex-end" }}
                      size={"small"}
                      label={props.article.count}
                      color={"primary"}
                    />
                  ) : null}

                  <div
                    className={props.enabled ? "article-price" : "article-price text-disabled"}
                    style={{
                      fontFamily: "PoppinsMedium",
                      fontWeight: 500,
                      color: "#888888",
                      marginLeft: "16px",
                      alignSelf: "flex-end",
                    }}
                  >
                    {props.article.originalPrice !== null && (
                      <span style={{ textDecoration: "line-through", marginRight: "6px", fontSize: "1.1em" }}>
                        {GetCurrency("€") +
                          parseFloat(props.article.originalPrice / 100).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                      </span>
                    )}
                    {props.article.price !== 0 ? (
                      <span style={{ color: props.article.originalPrice !== null ? "red" : null }}>
                        {(props.article.hasModifiergroupsWithPrice
                          ? props.intl.formatMessage({ id: "text_price_from" }) + " " + GetCurrency("€")
                          : GetCurrency("€")) +
                          parseFloat(props.article.price / 100).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>

        <Popper
          id={id}
          open={popoverIsOpen}
          anchorEl={anchorPopover}
          onClick={handleClosePopover}
          transition
          placement={"bottom-start"}
          style={{ zIndex: zIndex.modal }}
        >
          {({ TransitionProps }) => {
            return (
              <Fade {...TransitionProps} timeout={350}>
                <Paper className={classes.paper}>
                  <WarningIcon color={"error"} />
                  {numerable ? (
                    <Typography className={classes.typography}>
                      {modifiergroupName == null
                        ? props.intl.formatMessage({ id: "alert_text_selection_no_name" })
                        : props.intl.formatMessage(
                            { id: "alert_text_selection_max" },
                            {
                              modifiergroupName: modifiergroupName,
                              max: max,
                            }
                          )}
                    </Typography>
                  ) : (
                    <Typography className={classes.typography}>
                      {modifiergroupName == null
                        ? props.intl.formatMessage({ id: "alert_text_selection_no_name" })
                        : props.intl.formatMessage(
                            { id: "alert_text_selection" },
                            { modifiergroupName: modifiergroupName }
                          )}
                    </Typography>
                  )}
                </Paper>
              </Fade>
            );
          }}
        </Popper>
        {orderModifiergroups.map((orderModifiergroup: OrderModifiergroup, index) => {
          return (
            <div style={{ display: "flex", flexDirection: "column", paddingLeft: "20px" }} key={orderModifiergroup.id}>
              <span style={{ margin: "16px 0" }} id={"orderModifiergroupSpan-" + orderModifiergroup.id}>
                {orderModifiergroup.name}
              </span>
              <List className={classes.list}>
                {orderModifiergroup.orderModifierarticles.map((orderModifierarticle: OrderModifierarticle, index) => {
                  return (
                    <ListItem
                      className={index !== orderModifiergroup.orderModifierarticles.length - 1 ? classes.listItem : ""}
                      style={{
                        marginLeft: "32px",
                        display: "flex",
                        flexDirection: "row",
                        minHeight: "50px",
                        justifyContent: "space-between",
                        paddingRight: "8px",
                        paddingLeft: "0",
                        width: "auto",
                      }}
                      onClick={(event) => {
                        onModifierarticleClicked(orderModifiergroup, orderModifierarticle);
                      }}
                      key={orderModifierarticle.id}
                    >
                      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <div style={{ fontFamily: "Poppins", fontSize: "14px", color: "#888888" }}>
                          {orderModifierarticle.name}
                        </div>
                        <div
                          style={{ fontFamily: "PoppinsMedium", fontSize: "12px", color: "#888888", height: "18px" }}
                        >
                          {orderModifierarticle.price !== 0 && (
                            <div>
                              + {GetCurrency("€")}{" "}
                              {parseFloat(orderModifierarticle.price / 100.0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          visibility: mynOberStore.merchant.isOrdering ? "visible" : "hidden",
                        }}
                      >
                        {orderModifiergroup.numerable ? (
                          <AmountAddRemove
                            onRemoveClicked={() => {
                              if (orderModifierarticle.count > 0) {
                                orderModifierarticle.count--;
                                setOrderModifiergroups([...orderModifiergroups]);
                              }
                            }}
                            onAddClicked={() => {
                              if (orderModifiergroup.maxN > 0) {
                                if (orderModifiergroup.count === orderModifiergroup.maxN * count) {
                                  console.log("maxN reached");
                                  return;
                                }
                              }
                              orderModifierarticle.count++;
                              setOrderModifiergroups([...orderModifiergroups]);
                            }}
                            count={orderModifierarticle.count}
                          />
                        ) : null}
                        {!orderModifiergroup.numerable &&
                        (orderModifiergroup.multiple || orderModifiergroup.optional) ? (
                          <Checkbox color={"primary"} checked={orderModifierarticle.count === 1} />
                        ) : null}
                        {!orderModifiergroup.numerable &&
                        !orderModifiergroup.multiple &&
                        !orderModifiergroup.optional ? (
                          <Radio color={"primary"} checked={orderModifierarticle.count === 1} />
                        ) : null}
                      </div>
                    </ListItem>
                  );
                })}
              </List>
            </div>
          );
        })}
        {Number.isInteger(props.article?.allowRemark) && (
          <div style={{ margin: "24px", textAlign: "center" }}>
            <TextField
              margin={"dense"}
              rows={5}
              placeholder={"Vul hier je wensen in"}
              variant={"outlined"}
              value={remark}
              onChange={(e) => {
                setRemark(e.target.value);
              }}
              inputProps={{
                maxLength:
                  Number.isInteger(props.article.allowRemark) && props.article.allowRemark !== 0
                    ? props.article.allowRemark
                    : 128,
              }}
              multiline
            />
          </div>
        )}
      </DialogContentWithoutPadding>
      {mynOberStore.merchant.isOrdering ? (
        <DialogActions style={{ justifyContent: "center" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              flexWrap: "wrap",
              width: "100%",
            }}
          >
            {props.article != null ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexWrap: "wrap",
                  margin: "10px 20px",
                  width: "100%",
                }}
              >
                <div>
                  <AmountAddRemove
                    onRemoveClicked={() => {
                      if (count > 1) {
                        setCount(count - 1);
                      }
                    }}
                    onAddClicked={() => {
                      if (props.article.maxN > 0) {
                        if (count >= props.article.maxN) {
                          console.log("maxN reached");
                          return;
                        }
                      }
                      setCount(count + 1);
                    }}
                    count={count}
                  />
                </div>
                {orderArticlePrice !== 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", margin: "0 16px" }}>
                    <Typography
                      style={{
                        textAlign: "center",
                        minWidth: "80px",
                        fontFamily: "PoppinsMedium",
                        fontSize: "15px",
                      }}
                    >
                      {GetCurrency("€")}{" "}
                      {parseFloat(orderArticlePrice / 100).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                  </div>
                ) : null}
                <CircularButton
                  color={"primary"}
                  variant={"contained"}
                  style={{ fontFamily: "PoppinsMedium", margin: "8px 0" }}
                  disabled={!mynOberStore.isOrderingPossible()}
                  onClick={() => {
                    if (props.article.extraMessage) {
                      checkExtraMessage();
                    } else {
                      addToOrderClicked();
                    }
                  }}
                >
                  {props.intl.formatMessage({ id: "button_add_to_order" })}
                </CircularButton>
              </div>
            ) : null}
          </div>
        </DialogActions>
      ) : null}
    </>
  );
}

export default withIntl(HandheldViewMenuArticleDetailed);
